import React from 'react';
import { Checkbox, ListItemIcon } from '@mui/material';
import { useAppSelector } from 'store/hooks';
import { selectRoleDisplayName } from 'features/permissions/permissionsSlice';
import { styled } from '@mui/material/styles';
import AvatarNameEntity from 'components/AvatarNameEntity';
import { ContentLibraryUsersVirtualListItemType } from 'features/content-library/selectors/selectContentLibraryActiveUsers';
import { ShareUsersListContext } from 'features/content-library/components/share-users-selector/ShareFileUsersList';

export type ShareUsersListItemContentProps = {
  item: ContentLibraryUsersVirtualListItemType;
  context: ShareUsersListContext;
};

const StyledListItemIcon = styled(ListItemIcon)({
  minWidth: 'auto',
});

const ShareUsersListItemContent = React.memo(
  ({ item, context }: ShareUsersListItemContentProps) => {
    const { user, local } = item;

    const roleDisplayName = useAppSelector((state) => selectRoleDisplayName(state, user?.role));

    const { toggleUser, selectedIds, disabled } = context;

    if (!user) {
      return null;
    }

    const labelId = `share-user-checkbox-${user.id}`;

    return (
      <>
        <AvatarNameEntity
          id={labelId}
          src={user.avatarUrl}
          color={user.avatarColor}
          name={user.name!}
          initials={user.initials}
          secondary={roleDisplayName}
          local={local}
        />
        <StyledListItemIcon>
          <Checkbox
            edge="end"
            checked={selectedIds.indexOf(user.id) !== -1}
            disabled={disabled}
            tabIndex={-1}
            onChange={() => toggleUser(user.id)}
            slotProps={{
              input: { 'aria-labelledby': labelId },
            }}
          />
        </StyledListItemIcon>
      </>
    );
  }
);

export default ShareUsersListItemContent;
